import { Injectable } from '@angular/core';
import { SetReports } from '@core/store/report/report.actions';
import { Store } from '@ngxs/store';
import { ReportService } from '@core/services/report.service';
import { filter } from 'rxjs/operators';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ReportsResolver {
  constructor(private readonly reportService: ReportService, private readonly store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    this.reportService
      .getPowerBiReportList()
      .pipe(
        filter((response) => {
          return !!response?.length;
        }),
      )
      .subscribe((response) => {
        this.store.dispatch(new SetReports(response));
      });
  }
}
